<template>
  <view class="package-list" bind:scroll="handleScroll">
    <view>
      <view wx:if="{{packUsageList?.length}}">
        <packageUsageItem wx:for="{{packUsageList}}" wx:key="index" packageUsageItem="{{item}}" />
      </view>
      <view wx:elif="{{!isRequest && !packUsageList?.length}}" class="empty">
        <image class="empty-pic" src="https://ut-static.udache.com/webx/sfc/JWOpy8-v4rb8eAomah41o.png" />
        <view class="empty-text">暂无使用明细</view>
      </view>
    <Loading wx:if="{{isRequest}}" />
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getAccPackDetailApi } from '@/api/package'

  createComponent({
    props: {},
    created() {
      this.getAccPackDetail()
    },
    watch: {
      isAtBottom: {
        handler(val) {
          val &&
            setTimeout(() => {
              if (!this.isRequest && !this.noDataTip) {
                this.getAccPackDetail()
              }
            }, 300)
        },
        immediate: false
      }
    },
    data: {
      isAtBottom: false,
      isRequest: false,
      noDataTip: false,
      pageNumber: 1,
      packUsageList: []
    },
    computed: {},
    methods: {
      handleScroll(e) {
        const detail = __mpx_mode__ === 'web' ? e.target : e.detail
        const { offsetHeight, scrollTop, scrollHeight } = detail
        this.isAtBottom = scrollHeight - scrollTop - offsetHeight < 50 && scrollTop !== 0
      },
      async getAccPackDetail() {
        const params = {
          page_num: this.pageNumber,
          page_size: 10
        }
        this.isRequest = true
        await getAccPackDetailApi(params).then((res) => {
          const { data, success, message, code } = res || {}
          if (success && +code === 0) {
            this.isRequest = false
            this.pageNumber++
            if (data?.list?.length < 10) this.noDataTip = true
            
            this.packUsageList = [...this.packUsageList, ...data.list??[]]
          }
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
  .package-list
    padding 15px
    overflow-y auto
    .empty
      display flex
      align-items center
      flex-direction column
      padding-top 128px
      &-pic
        height 100px
        width 100px
        margin-bottom 16px
      &-text
        font-family PingFangSC-Regular
        font-weight 400
        font-size 13px
        line-height 13px
        letter-spacing 0px
        color #999999
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {
        packageUsageItem: './package-usage-item',
        Loading: '@/components/loading'
      }
    }
</script>